import { useParams, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ProfileNavbar from './ProfileNavbar';
import McpConnectSection from './McpConnectSection';
import './scss/Settings.scss';
import './scss/McpConnectSection.scss';

/**
 * "AI & Agents" settings tab — the home for connecting Zoobbe to external AI
 * agents (Claude, Cursor, ChatGPT, …) over MCP. User-level (spans all the
 * user's workspaces), so it lives under /u/:userName/ai-agents, not workspace
 * settings.
 */
const AiAgents = () => {
  const { userName } = useParams();
  const { user } = useSelector((state) => state.user);

  const isOwnSettings = user?.user?.username === userName;
  if (user?.user?.username && !isOwnSettings) {
    return <Navigate to={`/u/${user.user.username}/ai-agents`} replace />;
  }

  return (
    <>
      <ProfileNavbar />
      <div className="settings-container">
        <McpConnectSection />
      </div>
    </>
  );
};

export default AiAgents;
